import { PatientCase } from "../context/diagnosticAgent";
import { getQFAndRefinementsLines } from "fe-common/logic";
import { GenderValue } from "shared";
import { writeToGlobalStorage } from "fe-web-components/userStorage/globalUserStorage";
import { getCurrentUserEmail } from "@kahunmedical/user-management";

export type SavedCase = {
  patientId: string;
  title: string;
  createdOn: Date;
};

const SAVED_CASES_LOCAL_STORAGE = "DiagnosticAgent:SavedCases";

export async function saveCase(patientCase: PatientCase, patientId: string) {
  const age = patientCase.age?.low;
  const gender = patientCase?.gender;
  const [ccTitle, ccRefines] = getQFAndRefinementsLines(
    patientCase.main?.[0] ||
      patientCase.clinicalFeatures?.[0] ||
      patientCase.background?.[0],
  );
  const genderText =
    gender === GenderValue.MALE
      ? "Male"
      : gender === GenderValue.FEMALE
      ? "Female"
      : "";

  const title = `${(age && `${age} years old `) ||
    "Unknown age"} ${genderText} with ${ccTitle} ${
    ccRefines ? `(${ccRefines})` : ""
  }`;
  const casesToSave = await getSavedCases();

  const caseToSave: SavedCase = {
    title,
    patientId,
    createdOn: new Date(),
  };

  casesToSave.push(caseToSave);
  saveCases(casesToSave);
}

export async function getSavedCases(): Promise<SavedCase[]> {
  const userName = await getCurrentUserEmail();
  try {
    const savedCasesRaw = localStorage.getItem(
      `${userName}:${SAVED_CASES_LOCAL_STORAGE}`,
    );
    if (!savedCasesRaw) return [];
    return JSON.parse(savedCasesRaw);
  } catch (e) {
    console.log(e);
    return [];
  }
}

export async function saveCases(savedCases: SavedCase[]) {
  const raw = JSON.stringify(savedCases);
  const userName = await getCurrentUserEmail();
  // TODO: use writeAtomicGlobalStorage to read and save everytime an individual case (to avoid overrding certain cases)
  writeToGlobalStorage(`${userName}:${SAVED_CASES_LOCAL_STORAGE}`, raw);
}
